import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.UniformDesign;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "UniformDesign.Phaser.IntroductionScene.1",
            "UniformDesign.Phaser.IntroductionScene.2",
            "UniformDesign.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/UniformDesignGame/scenes/GameIntro.ts